export default class ButtonLoader {
    constructor(element) {
        this.$element = $(element);
        this.$textElement = this.$element.find('[data-loader-text]');
        this.$loaderElement = this.$element.find('[data-loader]');  // loader template container
    }

    show() {
        this.$element.prop('disabled', true);;
        this.$textElement.hide();
        this.$loaderElement.show();
        this.$loaderElement.removeClass('notransition');
        this.$loaderElement.find('[data-progress-circle]').attr('data-progress', 100);
    }

    hide() {
        this.$element.prop('disabled', false);;
        this.$textElement.show();
        this.$loaderElement.hide();
        this.$loaderElement.addClass('notransition');
        this.$loaderElement.find('[data-progress-circle]').attr('data-progress', 0);
    }

    init() {
        this.$element
            .off('loader:show', '', $.proxy(this, ''))
            .on('loader:show', $.proxy(this, 'show'));

        this.$element
            .off('loader:hide', '', $.proxy(this, ''))
            .on('loader:hide', $.proxy(this, 'hide'));
    }
}
